// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ******************* */
/*      CARD GRID      */
/* ******************* */

#card-grid {
  padding: 4rem var(--page-padding) 5rem;
  background: linear-gradient(180deg, #ffffff 0%, #f0f1ff 100%);

  h2 {
    margin-bottom: 2rem;
  }

  .card-container {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 2rem;
    margin: 0 auto;
  }

  .card {
    width: 100%;
    background: #ffffff;
    border-radius: 15px;
    box-shadow: var(--card-shadow);
    padding: 4rem 2rem 2.5rem;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;

    position: relative;
    margin-bottom: 1.75rem;
  }

  .card:last-of-type {
    margin-bottom: 0;
  }

  .gradient-bg {
    background: var(--gradient-pink);
    padding: 2rem;
    p {
      color: var(--body-text-color-light);
    }
  }

  img {
    width: 3.5rem;
    height: auto;
    position: absolute;
    top: -1.75rem;
  }

  a {
    color: var(--accent-color);
  }
}

/* TABLET */
@media only screen and (min-width: 48rem) {
  #card-grid {
    padding: 4rem calc(var(--page-padding) + 1.76px) 9rem;

    .card-container {
      grid-template-columns: repeat(2, 1fr);
    }

    .container {
      padding-top: 1.75rem;
    }

    .card-container {
      column-gap: 1.5rem;
    }
    .card {
      height: 322px;
    }

    .gradient-bg {
      padding: 4rem 2rem 2.5rem;
    }

    .card:nth-last-of-type(2) {
      margin-bottom: 0;
    }
  }
}

/* DESKTOP */
@media only screen and (min-width: 64rem) {
  #card-grid {
    .card-container {
      grid-template-columns: repeat(3, 1fr);
      column-gap: 2rem;
    }
    .card:nth-last-of-type(3) {
      margin-bottom: 0;
    }
  }
}

/* ******************* */
/*    IMAGE GALLERY    */
/* ******************* */

#image-gallery {
  padding: 2rem var(--page-padding) 4rem;
  .gallery {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .image {
    height: auto;
    width: 100%;
    background-color: var(--primary-color);
    border-radius: 0.25rem;
    /* border: 2px solid var(--accent-color); */
    box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .two-col {
    grid-column: span 2;
    grid-row: 2;
  }

  .three-row {
    display: none;
  }

  img {
    border-radius: inherit;
  }

  .attribution {
    display: block;
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 1.5% 3%;
    font-size: 0.7rem;
    text-align: start;
    color: var(--body-text-color-light);
    background-color: rgba(0, 0, 0, 0.2);
    a {
      color: inherit;
      text-decoration: underline;
    }
  }
}

@media only screen and (min-width: 48rem) {
  #image-gallery {
    .gallery {
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;
    }

    .three-row {
      display: block;
      grid-row: 1 / span 3;
      /* to align it to the right */
      grid-column: 3;
      /* to align it to the left */
      /* grid-column: 1; */
    }
  }
}

@media only screen and (min-width: 64rem) {
  #image-gallery {
    .gallery {
      row-gap: 1.5rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,sCAAsC;EACtC,6DAA6D;;EAE7D;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;;IAEzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;;IAEX,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,aAAa;IACb;MACE,mCAAmC;IACrC;EACF;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,WAAW;AACX;EACE;IACE,qDAAqD;;IAErD;MACE,qCAAqC;IACvC;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;IACA;MACE,aAAa;IACf;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA,YAAY;AACZ;EACE;IACE;MACE,qCAAqC;MACrC,gBAAgB;IAClB;IACA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,sCAAsC;EACtC;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,sBAAsB;IACtB,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;IACnC,oCAAoC;IACpC;MACE,cAAc;MACd,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE;IACE;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,cAAc;MACd,oBAAoB;MACpB,6BAA6B;MAC7B,cAAc;MACd,4BAA4B;MAC5B,oBAAoB;IACtB;EACF;AACF;;AAEA;EACE;IACE;MACE,eAAe;IACjB;EACF;AACF","sourcesContent":["/* ******************* */\n/*      CARD GRID      */\n/* ******************* */\n\n#card-grid {\n  padding: 4rem var(--page-padding) 5rem;\n  background: linear-gradient(180deg, #ffffff 0%, #f0f1ff 100%);\n\n  h2 {\n    margin-bottom: 2rem;\n  }\n\n  .card-container {\n    display: grid;\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: 2rem;\n    margin: 0 auto;\n  }\n\n  .card {\n    width: 100%;\n    background: #ffffff;\n    border-radius: 15px;\n    box-shadow: var(--card-shadow);\n    padding: 4rem 2rem 2.5rem;\n\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1.5rem;\n\n    position: relative;\n    margin-bottom: 1.75rem;\n  }\n\n  .card:last-of-type {\n    margin-bottom: 0;\n  }\n\n  .gradient-bg {\n    background: var(--gradient-pink);\n    padding: 2rem;\n    p {\n      color: var(--body-text-color-light);\n    }\n  }\n\n  img {\n    width: 3.5rem;\n    height: auto;\n    position: absolute;\n    top: -1.75rem;\n  }\n\n  a {\n    color: var(--accent-color);\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 48rem) {\n  #card-grid {\n    padding: 4rem calc(var(--page-padding) + 1.76px) 9rem;\n\n    .card-container {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    .container {\n      padding-top: 1.75rem;\n    }\n\n    .card-container {\n      column-gap: 1.5rem;\n    }\n    .card {\n      height: 322px;\n    }\n\n    .gradient-bg {\n      padding: 4rem 2rem 2.5rem;\n    }\n\n    .card:nth-last-of-type(2) {\n      margin-bottom: 0;\n    }\n  }\n}\n\n/* DESKTOP */\n@media only screen and (min-width: 64rem) {\n  #card-grid {\n    .card-container {\n      grid-template-columns: repeat(3, 1fr);\n      column-gap: 2rem;\n    }\n    .card:nth-last-of-type(3) {\n      margin-bottom: 0;\n    }\n  }\n}\n\n/* ******************* */\n/*    IMAGE GALLERY    */\n/* ******************* */\n\n#image-gallery {\n  padding: 2rem var(--page-padding) 4rem;\n  .gallery {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n\n  h2 {\n    font-size: 2rem;\n    margin-bottom: 1rem;\n  }\n\n  .image {\n    height: auto;\n    width: 100%;\n    background-color: var(--primary-color);\n    border-radius: 0.25rem;\n    /* border: 2px solid var(--accent-color); */\n    box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.1);\n    position: relative;\n  }\n\n  .two-col {\n    grid-column: span 2;\n    grid-row: 2;\n  }\n\n  .three-row {\n    display: none;\n  }\n\n  img {\n    border-radius: inherit;\n  }\n\n  .attribution {\n    display: block;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    padding: 1.5% 3%;\n    font-size: 0.7rem;\n    text-align: start;\n    color: var(--body-text-color-light);\n    background-color: rgba(0, 0, 0, 0.2);\n    a {\n      color: inherit;\n      text-decoration: underline;\n    }\n  }\n}\n\n@media only screen and (min-width: 48rem) {\n  #image-gallery {\n    .gallery {\n      grid-template-columns: repeat(3, 1fr);\n      gap: 1rem;\n    }\n\n    .three-row {\n      display: block;\n      grid-row: 1 / span 3;\n      /* to align it to the right */\n      grid-column: 3;\n      /* to align it to the left */\n      /* grid-column: 1; */\n    }\n  }\n}\n\n@media only screen and (min-width: 64rem) {\n  #image-gallery {\n    .gallery {\n      row-gap: 1.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
